import {
  updateParcel,
  parcelSelector,
  isMultiboxSelector,
} from '../../../../data/labelInfos/index.js'
import {showMultiboxModal} from '../../../LabelConfig/Modals/MultiboxModal/index.js'
import {useSelector} from '../../../../store.js'
import {UPS} from '../../../../common/constants/ShipperNames.js'
import ConfigCheckbox from '../ConfigCheckbox.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from '../useLabelProperty.js'

const LABEL_PROPERTY = 'packages[0].additional_handling'
const VALID_SHIPPER_TYPES = [UPS]

export default function AdditionalHandling({packagesIndex}) {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = AdditionalHandling.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  packagesIndex = packagesIndex || 0

  const additionalHandling = useSelector(
    (state) =>
      parcelSelector(state, {labelInfoID, packagesIndex}).additional_handling ||
      false,
  )
  const isMultibox = useSelector((state) =>
    isMultiboxSelector(state, {labelInfoID, shipperType}),
  )

  const label = 'Additional Handling'

  return (
    <ConfigCheckbox
      label={label}
      Label={() => (
        <>
          <span>{label}</span>
          {isMultibox && (
            <button
              className="btn btn--link margin-bottom-3 margin-left-3 fs-n0"
              type="button"
              onClick={() => showMultiboxModal(labelInfoID, shipperType)}
            >
              <em>(Multiple)</em>
            </button>
          )}
        </>
      )}
      onChange={(checked) => {
        updateParcel(labelInfoID, packagesIndex, {
          additional_handling: checked,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      checked={additionalHandling}
      disabled={isMultibox}
    />
  )
}

AdditionalHandling.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
